export default __webpack_public_path__ + "static/media/larger-pic-lb.df5bd1c4.jpg";